/** Deep links Telegram (PROJECT_SPEC §13.3). */

export const START_PARAM_RE = /^(inv|tx|c)_[A-Za-z0-9_-]{1,48}$/;

export type StartParam =
  | { kind: 'invite'; token: string }
  | { kind: 'transaction'; id: string }
  | { kind: 'connection'; id: string };

export function parseStartParam(raw: string | null | undefined): StartParam | null {
  if (!raw || !START_PARAM_RE.test(raw)) return null;
  const [prefix, value] = raw.split(/_(.*)/s) as [string, string];
  switch (prefix) {
    case 'inv':
      return { kind: 'invite', token: value };
    case 'tx':
      return { kind: 'transaction', id: value };
    case 'c':
      return { kind: 'connection', id: value };
    default:
      return null;
  }
}

export function botStartLink(botUsername: string, startParam: string): string {
  return `https://t.me/${botUsername}?start=${startParam}`;
}

/** Требует Mini App с short name `app` в BotFather (OPS-011). */
export function miniAppLink(botUsername: string, startParam: string): string {
  return `https://t.me/${botUsername}/app?startapp=${startParam}`;
}
